const Intro = ({breakPoints}) => {
    return (
      <div className={`flex justify-center items-center ${breakPoints} py-10`}>
        {/* Updated this div for responsive grid layout */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-9">
          {/* First column now taking 1/3 of the space on medium devices and up */}
          <div className="md:col-span-2 text-white flex flex-col justify-between">
            <div className="text-2xl text-left font-markForMC">
              We recognize that{" "}
              <i>
                She is Priceless because she makes business better and communities
                stronger.
              </i>
            </div>
          </div>
          {/* Second column now taking 2/3 of the space on medium devices and up */}
          <div className="md:col-span-3 text-white flex flex-col justify-between">
            <div className="text-xl md:text-md text-left font-markWebPro">
              In today's dynamic world, the quest for inclusivity remains
              paramount, especially in corporate landscapes traditionally
              perceived as male-dominated. Recognizing this, Mastercard has
              embarked on a transformative journey with its Diversity, Equity,
              and Inclusion (DEI) strategy with a special focus on Gender
              Balance.
            </div>
          </div>
        </div>
      </div>
    );
  };
  
export default Intro;
